import { render, staticRenderFns } from "./BottomEn.vue?vue&type=template&id=5bddce3c&"
import script from "./BottomEn.vue?vue&type=script&lang=js&"
export * from "./BottomEn.vue?vue&type=script&lang=js&"
import style0 from "./BottomEn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports